import React from "react"

import UniversalLink from "../../../../design-system/universal-link"
import BlogTagCollection from "../../../../shared-components/blog-tag-collection"
import BlogTitleAndMetadata from "../../../../shared-components/blog-title-and-metadata"
import { DatoImage } from "../../../../shared-components/dato-image"
import { Viewport } from "../../../../utils/constants"
import { BlogPostPreview, BlogTag } from "../../../blog/types"
import * as styles from "./index.module.scss"

type Props = Omit<BlogPostPreview, "tags"> & {
  tags?: BlogTag[]
}

const BlogPostSummary: React.FC<Props> = ({
  title,
  slug,
  coverImage,
  minutesOfReading,
  tags,
  updatedAt,
}) => {
  const url = `/blog/${slug}`
  return (
    <div className={styles.container} data-testid="blog-post-summary">
      <UniversalLink to={url} className={styles.container}>
        <DatoImage
          className={styles.image}
          data={{
            src: coverImage.url,
            alt: coverImage.alt,
            width: 669,
          }}
          srcSetCandidates={[
            { imgWidth: 330 * 2, minViewport: 0 },
            { imgWidth: 669 * 2, minViewport: 425 },
            { imgWidth: 285 * 2, minViewport: Viewport.small },
          ]}
        />
      </UniversalLink>
      {!!tags?.length && <BlogTagCollection tags={tags} />}
      <div className={styles.titleContainer}>
        <BlogTitleAndMetadata
          title={title}
          date={updatedAt}
          minutesOfReading={minutesOfReading}
          url={url}
        />
      </div>
    </div>
  )
}

export default BlogPostSummary
